// extracted by css-extract-rspack-plugin
export default {"overlay":"Overlay-module__overlay__mRJknEn"};